import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext, httpResource } from '@angular/common/http';
import { IAccountInfo, EventTypeEnum } from '@dss-libs/shared/type/common-types';
import { API_URL } from '@dss-libs/shared/utility/global-injection-tokens';
import { SnackbarService } from '@dss-libs/shared/utility/common-services';
import { catchError, tap, throwError } from 'rxjs';
import { USERS_URLS } from '../../urls/users.urls';
import { ClientService } from '@dss-libs/shared/data-access/clients';
import { formGroupToFormData } from '@dss-libs/shared/utility/common-utilities';

@Injectable({
  providedIn: 'root',
})
export class AccountInfoService {
  readonly #http = inject(HttpClient);
  readonly #apiUrl = inject(API_URL);
  readonly #snackbarService = inject(SnackbarService);
  readonly #clientsService = inject(ClientService);

  accountInfoResource() {
    return httpResource<IAccountInfo>(() => `${this.#apiUrl}${USERS_URLS.ACCOUNT_INFO}`);
  }

  updateAccountInfo(model: Partial<IAccountInfo>, file?: File | null, context?: HttpContext) {
    const formData = formGroupToFormData({ ...model, ...(file ? { profilePicture: file } : {}) });
    return this.#http.put<void>(`${this.#apiUrl}${USERS_URLS.ACCOUNT_INFO}`, formData, { context }).pipe(
      tap(() => {
        this.#updateNameInToken(model.firstName!, model.lastName!);
      }),
      catchError((err) => {
        this.#snackbarService.showToaster(EventTypeEnum.ERROR, 'SETTINGS.FAILED_TO_UPDATE_ACCOUNT_SETTINGS');
        return throwError(() => err);
      })
    );
  }

  #updateNameInToken(firstName: string, lastName: string) {
    this.#clientsService.updateResolvedToken({
      ...this.#clientsService.tokenData,
      name: `${firstName} ${lastName}`,
    });
  }
}
